import { FC } from 'react';

import { IconProps } from '../types';

export const YandexDzenIcon: FC<IconProps> = ({
	size,
	height = 18,
	width = 18,
	color = '#06519E',
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 18 18"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M8.983 0c3.54 0 5.617.358 7.077 1.776 1.49 1.52 1.834 3.583 1.834 7.121v.1c0 3.54-.344 5.617-1.834 7.121-1.461 1.419-3.524 1.777-7.078 1.777h-.07c-3.553 0-5.631-.358-7.078-1.777C.344 14.598 0 12.536 0 8.998v-.1c0-3.54.344-5.617 1.834-7.122C3.294.358 5.359 0 8.912 0h.071Zm.106 2.13h-.285a.13.13 0 0 0-.128.124c-.092 2.45-.403 3.94-1.447 4.984C6.187 8.28 4.7 8.59 2.254 8.684a.128.128 0 0 0-.124.128v.285a.13.13 0 0 0 .124.128c2.445.092 3.934.404 4.975 1.446 1.042 1.04 1.353 2.526 1.446 4.968a.128.128 0 0 0 .128.123h.286a.13.13 0 0 0 .128-.123c.094-2.442.405-3.927 1.446-4.968 1.043-1.043 2.53-1.354 4.976-1.446a.128.128 0 0 0 .123-.128v-.285a.128.128 0 0 0-.122-.128c-2.446-.093-3.934-.405-4.976-1.446C9.621 6.194 9.31 4.705 9.217 2.254a.128.128 0 0 0-.128-.124Z"
		/>
	</svg>
);
